import { ImageMapEntry, SeasonImageMap } from '../store/products/packsIndexNormalize';

function variantKey(masterId: string, colorCode: string): string {
    return String(masterId || '') + '_' + String(colorCode || '');
}

export function packImagesForProduct(
    imageMap: SeasonImageMap | undefined,
    product: { masterId: string; colorCode: string }
): ImageMapEntry[] {
    if (!imageMap || !product) {
        return [];
    }

    const exactKey = variantKey(product.masterId, product.colorCode);
    if (imageMap[exactKey]) {
        return imageMap[exactKey];
    }

    const upperKey = exactKey.toUpperCase();
    const lowerKey = exactKey.toLowerCase();
    const keys = Object.keys(imageMap);

    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (key.toUpperCase() === upperKey || key.toLowerCase() === lowerKey) {
            return imageMap[key];
        }
    }

    return [];
}
